<div>
  <h2>Server file whitelisting</h2>

  <p>Add files for FiveM AC whitelisting</p>

  <input type="file" (change)="filesSelected($event.target)" />
</div>
